import type { AnyShippingMethod, CheckoutV2Configuration } from "@jti/commerce";
import type { AddressCustomShippingFieldValue, ExternalShippingCarrierAddress } from "@jti/commerce-types";
import { type Translate } from "@jti/ui";

import type { FormFieldConfig } from "@checkout-v2/formFields/types/FormFieldConfig.types";
import type { FormFieldFactory } from "@checkout-v2/formFields/types/FormFieldFactory.types";

import { validateExternalCarrierAddress } from "./utils/validateExternalCarrierAddress";

export type AddressCustomShippingFieldConfig = FormFieldConfig<
  "addressCustomShipping",
  {
    shippingMethods: AnyShippingMethod[];
  }
>;

export const addressCustomShippingFieldFactory: FormFieldFactory<
  "addressCustomShipping",
  AddressCustomShippingFieldValue,
  [CheckoutV2Configuration, Translate],
  [],
  AddressCustomShippingFieldConfig
> = {
  getDerivedConfig: (checkoutConfiguration, translate) => {
    return {
      name: "addressCustomShipping",
      shippingMethods: checkoutConfiguration.shippingMethods,
      registerOptions: {
        required: translate("cart.checkout.delivery.custom.error.address_validation"),
        validate: (address: ExternalShippingCarrierAddress) => {
          return !validateExternalCarrierAddress(address)
            ? translate("cart.checkout.delivery.custom.error.address_validation")
            : true;
        },
      },
    };
  },
  getDefaultValue: () => {
    return null;
  },
};
